/**
 * siteConfig.js — the honesty setting: what has actually shipped.
 *
 * Surfaces are being built for real, and the site must say exactly which are
 * live. Every "live / coming soon / waitlist / Email today. Every surface
 * next." string on the site reads from here: the home page (hero meta row,
 * Every Surface tabs), the final CTA band, the footer's Surfaces column, the
 * How It Works tiles and the waitlist page.
 *
 * Q1 gate (Everywhere expansion report): no new surface goes public before the
 * Q1 gates are met (target Feb 28, 2027). Keep LIVE_SURFACES = 1 until then.
 *
 * Dependency-free so the build-time prerender (scripts/prerender.mjs, via
 * seo/routes.js) can import it too.
 */

// How many surfaces are live, counted in SURFACES order (1–4).
export const LIVE_SURFACES = 1;
// false hides the roadmap (not-yet-live) tiles on /how-it-works entirely.
export const SHOW_ROADMAP = true;
// The consistency score isn't built yet; it carries a COMING SOON pill until it is.
export const SCORE_COMING_SOON = true;
// The product loops autoplay. prefers-reduced-motion always wins over this.
export const AUTOPLAY = true;

export const SURFACES = [
  { key: 'gmail', name: 'Gmail' },
  { key: 'linkedin', name: 'LinkedIn' },
  { key: 'slack', name: 'Slack' },
  { key: 'whatsapp', name: 'WhatsApp' },
];

export const LIVE_COUNT = Math.max(1, Math.min(SURFACES.length, Math.round(LIVE_SURFACES)));
export const LIVE = SURFACES.slice(0, LIVE_COUNT);
export const SOON = SURFACES.slice(LIVE_COUNT);
export const ALL_LIVE = SOON.length === 0;

export const WAITLIST_PATH = '/waitlist';

export function isLive(key) {
  const i = SURFACES.findIndex((s) => s.key === key);
  return i >= 0 && i < LIVE_COUNT;
}

/** ['Gmail'] → "Gmail"; ['Gmail', 'LinkedIn', 'Slack'] → "Gmail, LinkedIn and Slack". */
export function listOf(names) {
  if (names.length < 2) return names[0] || '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

const LIVE_NAMES = listOf(LIVE.map((s) => s.name));
const SOON_NAMES = listOf(SOON.map((s) => s.name));

/** The honesty line: the Act 1 pill, the roadmap tiles, the final CTA. */
export const HONESTY_LINE = LIVE_COUNT === 1
  ? 'Email today. Every surface next.'
  : ALL_LIVE ? `Live on ${LIVE_NAMES} today.` : `Live on ${LIVE_NAMES} today. Every surface next.`;

/** The final CTA band's sub-line, on every page that carries it. */
export const CTA_SUB = `Free to start. ${HONESTY_LINE}`;

/** Home hero meta row: "Live in Gmail" + "LinkedIn, Slack and WhatsApp coming soon" (→ waitlist). */
export const HERO_LIVE = `Live in ${LIVE_NAMES}`;
export const HERO_SOON = ALL_LIVE ? '' : `${SOON_NAMES} coming soon`;

export { LIVE_NAMES, SOON_NAMES };
